import { useGetUserQuery } from "@generated";
import { RootState } from "@reducers/rootReducer";
import { useSelector } from "react-redux";
import { User, Role } from "../Users/common/types/User";

const useGetUser = (userId: number) => {
  const { accountSlug } = useSelector((state: RootState) => state.slug);
  const { data, error, isLoading } = useGetUserQuery({
    slug: accountSlug,
    id: userId,
  });

  let user: User | undefined = undefined;
  let customError: string | null = null;

  if (data?.data && data.data.id) {
    try {
      const roles: Role[] = (data.data.attributes?.roles || []).map((r) => ({
        id: r.id,
        name: r.name ?? "",
      }));

      const teamRelationships =
        data.data.relationships?.teams?.data?.map((t) => ({
          id: Number(t.id),
          type: t.type ?? "",
        })) || [];

      user = {
        id: Number(data.data?.id) || 0,
        type: data.data.type,
        attributes: {
          name: data.data.attributes?.name || "",
          phone: data.data.attributes?.phone || "",
          email: data.data.attributes?.email || "",
          title: data.data.attributes?.title || "",
          roles,
          userType: data.data.attributes?.["user-type"] || "",
        },
        relationships: {
          teams: {
            data: teamRelationships,
          },
        },
      };
    } catch (err) {
      if (err instanceof Error) {
        customError = err.message;
      } else {
        customError = "An unknown error occurred";
      }
    }
  }

  return { user, error: error || customError, isLoading };
};

export default useGetUser;
